import { render, staticRenderFns } from "./TemplateImport.vue?vue&type=template&id=62168087&"
import script from "./TemplateImport.vue?vue&type=script&lang=js&"
export * from "./TemplateImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports